import { Modal } from '@material-ui/core'
import { CreateGoalGroupInput, GoalGroupCard } from 'Generated/graphql-types'
import { GoalGroupInputs } from './GoalGroupInputs'
import {
  Copy,
  GoalGroupModalContainer,
  Header,
  Text,
} from './GoalGroupModal.styled'

type GoalGroupModalProps = {
  loading?: boolean
  goalGroup?: GoalGroupCard
  isOpen: boolean
  onClose: () => void
  onSubmit: (goalGroup: CreateGoalGroupInput) => Promise<boolean>
}

export const GoalGroupModal = ({
  loading,
  goalGroup,
  isOpen,
  onClose,
  onSubmit,
}: GoalGroupModalProps) => (
  <Modal
    open={isOpen}
    onClose={onClose}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    disableEnforceFocus
  >
    <GoalGroupModalContainer>
      <Copy>
        <Header>Edit Goal</Header>
        <Text>
          Changes made here will only apply to this goal and will not change any
          connected grantees goals.
        </Text>
      </Copy>
      <GoalGroupInputs
        isLoading={loading}
        goalGroup={goalGroup}
        onCancel={onClose}
        onCancelLabel='Go Back Without Saving'
        onSubmit={onSubmit}
        onSubmitLabel='Save Changes'
      />
    </GoalGroupModalContainer>
  </Modal>
)
